import ComponentHeader from 'components/admin/Helper/ComponentHeader'
import ComponentPlaceholder from 'components/admin/Helper/ComponentPlaceholder'
import config from 'config/config'

import { I18n } from 'lib/i18n'
import { classNames } from 'lib/utilities'
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { importProducts } from 'redux/importer'
import { confirmationModal } from 'redux/navigation'
import { archiveAllProducts, updateAllProducts } from 'redux/product'
import { Button, Header, Segment, Table } from 'semantic-ui-react'
import Badge from '../Helper/Badge'

const mapStateToProps = (state, ownProps) => {
  const {
    loadingProductState, // boolean showing state (new, updated, deleted) is loading
    productState, // object reflecting new, changed, deleted products, errors and import date
  } = state.importer
  const { language } = state.navigation
  return { loadingProductState, productState, language }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      importProducts,
      push,
      confirmationModal,
      updateAllProducts,
      archiveAllProducts,
    },
    dispatch
  )
}

const itemsPerPage = 10

class ImporterProducts extends React.Component {
  state = {
    newProductsPageNumber: 0,
    updatedProductsPageNumber: 0,
    deletedProductsPageNumber: 0,
  }

  constructor(props) {
    super(props)
    this.increaseNewProductsPage = this.increaseNewProductsPage.bind(this)
    this.decreaseNewProductsPage = this.decreaseNewProductsPage.bind(this)
    this.increaseUpdatedProductsPage = this.increaseUpdatedProductsPage.bind(
      this
    )
    this.decreaseUpdatedProductsPage = this.decreaseUpdatedProductsPage.bind(
      this
    )
    this.increaseDeletedProductsPage = this.increaseDeletedProductsPage.bind(
      this
    )
    this.decreaseDeletedProductsPage = this.decreaseDeletedProductsPage.bind(
      this
    )
  }

  getProductRows(products, path, pageVariable) {
    const { [pageVariable]: pageNumber } = this.state
    const { language } = this.props
    const { push } = this.props

    return products
      .slice(pageNumber * itemsPerPage, (pageNumber + 1) * itemsPerPage)
      .map((product, index) => (
        <Table.Row
          onClick={(event) => {
            event.preventDefault()
            push(path + product.article_number)
          }}
          key={index}
          verticalAlign="top">
          <Table.Cell>
            {product.article_number}
            <br />
            <span
              className="unobtrusive ellipsis"
              children={product.wd_title}
            />
          </Table.Cell>
          <Table.Cell
            className="unobtrusive"
            textAlign="right"
            children={new Date(product.updated_at).toLocaleDateString(
              language,
              config.format.date_time
            )}
          />
        </Table.Row>
      ))
  }

  decreaseNewProductsPage() {
    const { newProductsPageNumber } = this.state
    this.setState({ newProductsPageNumber: newProductsPageNumber - 1 })
  }

  increaseNewProductsPage() {
    const { newProductsPageNumber } = this.state
    this.setState({ newProductsPageNumber: newProductsPageNumber + 1 })
  }

  decreaseUpdatedProductsPage() {
    const { updatedProductsPageNumber } = this.state
    this.setState({ updatedProductsPageNumber: updatedProductsPageNumber - 1 })
  }

  increaseUpdatedProductsPage() {
    const { updatedProductsPageNumber } = this.state
    this.setState({ updatedProductsPageNumber: updatedProductsPageNumber + 1 })
  }

  decreaseDeletedProductsPage() {
    const { deletedProductsPageNumber } = this.state
    this.setState({ deletedProductsPageNumber: deletedProductsPageNumber - 1 })
  }

  increaseDeletedProductsPage() {
    const { deletedProductsPageNumber } = this.state
    this.setState({ deletedProductsPageNumber: deletedProductsPageNumber + 1 })
  }

  render() {
    const {
      newProductsPageNumber,
      updatedProductsPageNumber,
      deletedProductsPageNumber,
    } = this.state
    const { loadingProductState, productState } = this.props
    const { push } = this.props
    const {
      confirmationModal,
      updateAllProducts,
      archiveAllProducts,
    } = this.props

    const newProductsPages = Math.ceil(productState.new.length / itemsPerPage)
    const updatedProductsPages = Math.ceil(
      productState.updated.length / itemsPerPage
    )
    const deletedProductsPages = Math.ceil(
      productState.deleted.length / itemsPerPage
    )

    const dark = config.theme.dark

    return loadingProductState ? (
      <ComponentPlaceholder inverted={dark} />
    ) : (
      <div className={classNames(['importerProducts', dark && 'inverted'])}>
        <ComponentHeader
          title={I18n.t('admin.importer.products.title')}
          customActions={[
            <Button
              icon="chevron right"
              labelPosition="right"
              color="blue"
              content={I18n.t('admin.importer.products.all')}
              onClick={(event) => {
                event.preventDefault()
                push(config.nodes.productsFromDashboard)
              }}
            />,
          ]}
        />

        <Segment attached className="filterBar primary status">
          {productState.last_sync && (
            <Header
              as="h4"
              content={I18n.t('admin.importer.dealers.last_sync', {
                lastSync: new Date(productState.last_sync).toLocaleString(),
              })}
            />
          )}
          {productState.last_change && (
            <Header
              as="h4"
              className="important"
              content={I18n.t('admin.importer.dealers.last_change', {
                lastChange: new Date(productState.last_change).toLocaleString(),
              })}
            />
          )}
        </Segment>

        <Segment
          disabled={!productState.new_count > 0}
          attached
          className={classNames([dark && 'inverted', 'payload', 'clip'])}>
          <Header size="medium" className="payload-title">
            {I18n.t('admin.importer.products.new_products')}
            <Badge count={productState.new_count} />
          </Header>

          <Table
            inverted={dark}
            sortable
            compact
            size="small"
            selectable
            singleLine
            basic="very"
            className="spaced">
            <Table.Body
              children={this.getProductRows(
                productState['new'],
                config.nodes.productImport,
                'newProductsPageNumber'
              )}
            />
          </Table>
          {newProductsPages > 0 && (
            <Segment
              basic
              textAlign="right"
              className={classNames([dark && 'inverted', 'pagination'])}>
              <Button
                icon="angle left"
                disabled={newProductsPageNumber === 0}
                onClick={this.decreaseNewProductsPage}
              />
              {newProductsPageNumber + 1} / {newProductsPages}
              <Button
                icon="angle right"
                disabled={newProductsPageNumber + 1 === newProductsPages}
                onClick={this.increaseNewProductsPage}
              />
            </Segment>
          )}
        </Segment>

        <Segment
          disabled={!productState.updated_count > 0}
          attached
          className={classNames([dark && 'inverted', 'payload', 'clip'])}>
          <Header size="medium" className="payload-title">
            {I18n.t('admin.importer.products.changed_products')}
            <Badge count={productState.updated_count} />
            <Button
              disabled={!productState.updated_count > 0}
              inverted={dark}
              content={I18n.t('admin.importer.products.import_all')}
              size="tiny"
              floated="right"
              icon={config.icons.modalApprove}
              onClick={() =>
                confirmationModal({
                  icon: config.icons.modalApprove,
                  title: I18n.t('admin.importer.products.import_changed'),
                  text: I18n.t(
                    'admin.importer.products.import_updated_confirmation',
                    { numItems: productState.updated_count }
                  ),
                  button: I18n.t('admin.importer.products.import_all'),
                  confirm: () => updateAllProducts(),
                })
              }
            />
          </Header>
          <Table
            inverted={dark}
            sortable
            compact
            size="small"
            selectable
            singleLine
            basic="very"
            className="spaced">
            <Table.Body
              children={this.getProductRows(
                productState['updated'],
                config.nodes.productCompare,
                'updatedProductsPageNumber'
              )}
            />
          </Table>
          {updatedProductsPages > 0 && (
            <Segment
              basic
              textAlign="right"
              className={classNames([dark && 'inverted', 'pagination'])}>
              <Button
                icon="angle left"
                disabled={updatedProductsPageNumber === 0}
                onClick={this.decreaseUpdatedProductsPage}
              />
              {updatedProductsPageNumber + 1} / {updatedProductsPages}
              <Button
                icon="angle right"
                disabled={
                  updatedProductsPageNumber + 1 === updatedProductsPages
                }
                onClick={this.increaseUpdatedProductsPage}
              />
            </Segment>
          )}
        </Segment>

        <Segment
          disabled={!productState.deleted_count > 0}
          attached
          className={classNames([dark && 'inverted', 'payload', 'clip'])}>
          <Header size="medium" className="payload-title">
            {I18n.t('admin.importer.products.deleted_products')}
            <Badge count={productState.deleted_count} />
            <Button
              disabled={!productState.deleted_count > 0}
              inverted={dark}
              content={I18n.t('admin.importer.products.archive_all')}
              size="tiny"
              floated="right"
              icon={config.icons.modalDelete}
              onClick={() =>
                confirmationModal({
                  icon: config.icons.modalDelete,
                  negative: true,
                  title: I18n.t('admin.importer.products.archive_deleted'),
                  text: I18n.t(
                    'admin.importer.products.archive_deleted_confirmation',
                    { numItems: productState.deleted_count }
                  ),
                  button: I18n.t('admin.importer.products.archive_all'),
                  confirm: () => archiveAllProducts(),
                })
              }
            />
          </Header>
          <Table
            inverted={dark}
            sortable
            compact
            size="small"
            selectable
            singleLine
            basic="very"
            className="spaced">
            <Table.Body
              children={this.getProductRows(
                productState['deleted'],
                config.nodes.product,
                'deletedProductsPageNumber'
              )}
            />
          </Table>
          {deletedProductsPages > 0 && (
            <Segment
              basic
              textAlign="right"
              className={classNames([dark && 'inverted', 'pagination'])}>
              <Button
                icon="angle left"
                disabled={deletedProductsPageNumber === 0}
                onClick={this.decreaseDeletedProductsPage}
              />
              {deletedProductsPageNumber + 1} / {deletedProductsPages}
              <Button
                icon="angle right"
                disabled={
                  deletedProductsPageNumber + 1 === deletedProductsPages
                }
                onClick={this.increaseDeletedProductsPage}
              />
            </Segment>
          )}
        </Segment>
      </div>
    )
  }
}

ImporterProducts = connect(mapStateToProps, mapDispatchToProps)(
  ImporterProducts
)
export default ImporterProducts



// WEBPACK FOOTER //
// ./src/components/admin/Importer/ImporterProducts.jsx